import { Text } from "components";
import React from "react";

export default function SolutionTable({
  titleText = "WealthTech",
  bodyText = "Enhance your platform’s holistic view of your portfolios with reliable risk analytics from TRG. Leverage our dashboard or download bulk risk metrics through our API for seamless integration with your own dashboards.",
  ...props
}) {
  return (
    <div {...props}
    className={`${props.className} flex flex-col items-center sm:w-full gap-10 px-[5px] py-6 sm:px-5 border-black-900_01 border border-solid bg-gray-300`}
   >
      <div className="flex flex-col items-center h-[40px] self-stretch">
        <div className="text-[22px] font-semibold text-indigo-700 text-center w-full">
          {titleText}
        </div>
      </div>
      <div className="mb-10 flex flex-col gap-2.5 self-stretch">
        <div className="flex items-start justify-center gap-2.5">
          <Text as="p" className="w-[88%] self-center text-[18px] font-normal leading-[120%] text-black-900">
            {bodyText}
          </Text>
        </div>
      </div>
    </div>
  );
}
